module.exports = __webpack_public_path__ + "img/404-gif.1d2a7908.gif";